// utils/jetonFragment.js
// Jeton reçu dans le fragment de l'adresse (#jeton=...) par un lien d'e-mail. Le fragment n'est pas
// envoyé au serveur par le navigateur. Un lien cliqué dans l'onglet déjà ouvert ne change QUE le
// fragment (la page n'est pas rechargée) : on le relit donc à l'ouverture ET à chaque changement,
// on l'efface de l'adresse, et le jeton lu reste en mémoire dans l'état de la page.

import { useEffect, useRef, useState } from 'react';

export const lireJetonFragment = () => new URLSearchParams(window.location.hash.replace(/^#/, '')).get('jeton') || '';

/**
 * Renvoie le jeton courant. `auNouveauJeton(jeton)` est appelé à chaque nouveau jeton lu (ouverture
 * comprise) : la page y remet son état à zéro, pour ne jamais garder l'erreur d'un jeton précédent.
 */
export function useJetonFragment(auNouveauJeton) {
  const [jeton, setJeton] = useState(lireJetonFragment);
  const rappel = useRef(auNouveauJeton);
  rappel.current = auNouveauJeton;

  useEffect(() => {
    const prendreJeton = () => {
      const nouveau = lireJetonFragment();
      if (!nouveau) return;
      setJeton(nouveau);
      if (rappel.current) rappel.current(nouveau);
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    };
    prendreJeton();
    window.addEventListener('hashchange', prendreJeton);
    return () => window.removeEventListener('hashchange', prendreJeton);
  }, []);

  return jeton;
}
